export default __webpack_public_path__ + "alberta-chat-channel-list-offline.059796c59d6362babf54.svg";